
import RegisterForm from './register-form.vue'
export default RegisterForm